export default __webpack_public_path__ + "static/media/ship.9216ab8c.png";